"use strict";
const knNumbersWithProductCode = [
    {
        knNumber: '15071010',
        exciseProductCode: 'E200',
        description: 'Soya-bean oil, crude, whether or not degummed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15079010',
        exciseProductCode: 'E200',
        description: 'Soya-bean oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15081010',
        exciseProductCode: 'E200',
        description: 'Groundnut oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15089010',
        exciseProductCode: 'E200',
        description: 'Groundnut oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15092000',
        exciseProductCode: 'E200',
        description: 'Extra virgin olive oil',
    },
    {
        knNumber: '15093000',
        exciseProductCode: 'E200',
        description: 'Virgin olive oil, not chemically modified',
    },
    {
        knNumber: '15094000',
        exciseProductCode: 'E200',
        description: 'Virgin olive oil other than extra virgin, but not chemically modified',
    },
    {
        knNumber: '15099000',
        exciseProductCode: 'E200',
        description: 'Other than virgin olive oil, not chemically modified',
    },
    {
        knNumber: '15101000',
        exciseProductCode: 'E200',
        description: 'Other oils, Crude olive pomace oil, obtained solely from olives, whether or not refined, but not chemically modified',
    },
    {
        knNumber: '15109000',
        exciseProductCode: 'E200',
        description: 'Oils, other than Crude olive pomace oil, obtained solely from olives, whether or not refined, but not chemically modified',
    },
    {
        knNumber: '15111010',
        exciseProductCode: 'E200',
        description: 'Palm oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15119011',
        exciseProductCode: 'E200',
        description: 'Solid fractions of other palm oil than crude palm oil, whether or not refined, in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15119019',
        exciseProductCode: 'E200',
        description: 'Solid fractions of other palm oil than crude palm oil, not in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15119091',
        exciseProductCode: 'E200',
        description: 'Liquid fractions of other palm oil than crude palm oil, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15121110',
        exciseProductCode: 'E200',
        description: 'Sunflower-seed or safflower oil or cotton-seed, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15121910',
        exciseProductCode: 'E200',
        description: 'Sunflower-seed or safflower oil or cotton-seed, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15122110',
        exciseProductCode: 'E200',
        description: 'Cotton-seed oil, crude, whether or not gossypol has been removed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15122910',
        exciseProductCode: 'E200',
        description: 'Cotton-seed oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15131110',
        exciseProductCode: 'E200',
        description: 'Crude coconut oil for technical or industrial use',
    },
    {
        knNumber: '15131911',
        exciseProductCode: 'E200',
        description: 'Solid fractions of coconut (copra) oil, whether or not refined, in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15131919',
        exciseProductCode: 'E200',
        description: 'Solid fractions of coconut (copra) oil, whether or not refined, not in immediate packings of a net content exceeding 1 kg',
    },
    {
        knNumber: '15131930',
        exciseProductCode: 'E200',
        description: 'Not solid fractions of coconut (copra) oil, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15132110',
        exciseProductCode: 'E200',
        description: 'Palm kernel or babassu oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15132911',
        exciseProductCode: 'E200',
        description: 'Solid fractions of palm kernel or babassu oil, not crude, whether or not refined, in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15132919',
        exciseProductCode: 'E200',
        description: 'Solid fractions of palm kernel or babassu oil, whether or not refined, not crude, not in immediate packings of a net content exceeding 1 kg',
    },
    {
        knNumber: '15132930',
        exciseProductCode: 'E200',
        description: 'Liquid fractions of palm kernel or babassu oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15141110',
        exciseProductCode: 'E200',
        description: 'Low erucic acid rape or colza oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15141910',
        exciseProductCode: 'E200',
        description: 'Low erucic acid rape or colza oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15149110',
        exciseProductCode: 'E200',
        description: 'Mustard oil, whether or not refined, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15149910',
        exciseProductCode: 'E200',
        description: 'Mustard oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15151100',
        exciseProductCode: 'E200',
        description: 'Linseed oil, crude',
    },
    {
        knNumber: '15151910',
        exciseProductCode: 'E200',
        description: 'Linseed oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15152110',
        exciseProductCode: 'E200',
        description: 'Maize (corn) oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15152910',
        exciseProductCode: 'E200',
        description: 'Maize (corn) oil, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15153090',
        exciseProductCode: 'E200',
        description: 'Castor oil, whether or not refined, for technical or industrial uses other than the production of amino-undecanoic acid for use in the manufacture of synthetic textile fibres or of artificial plastic materials',
    },
    {
        knNumber: '15155011',
        exciseProductCode: 'E200',
        description: 'Sesame oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15155091',
        exciseProductCode: 'E200',
        description: 'Sesame oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15156011',
        exciseProductCode: 'E200',
        description: 'Microbial fats and oils and their fractions, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15156060',
        exciseProductCode: 'E200',
        description: 'Microbial fats and oils and their fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15159011',
        exciseProductCode: 'E200',
        description: 'Tung oil; jojoba and oiticica oils; myrtle wax and Japan wax; their fractions',
    },
    {
        knNumber: '15159021',
        exciseProductCode: 'E200',
        description: 'Tobacco-seed oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15159031',
        exciseProductCode: 'E200',
        description: 'Tobacco-seed oil and its fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15159040',
        exciseProductCode: 'E200',
        description: 'Other fixed vegetable fats and oils, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15159060',
        exciseProductCode: 'E200',
        description: 'Other fixed vegetable fats and oils and their fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15161010',
        exciseProductCode: 'E200',
        description: 'Animal fats and oils and their fractions in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15161090',
        exciseProductCode: 'E200',
        description: 'Animal fats and oils and their fractions in immediate packings of a net content exceeding 1 kg',
    },
    {
        knNumber: '15162010',
        exciseProductCode: 'E200',
        description: "Hydrogenated castor oil, so called 'opal-wax'",
    },
    {
        knNumber: '15162091',
        exciseProductCode: 'E200',
        description: 'Vegetable fats and oils and their fractions in immediate packings of a net content not exceeding 1 kg',
    },
    {
        knNumber: '15162095',
        exciseProductCode: 'E200',
        description: 'Colza, linseed, rapeseed, sunflower-seed, illipe, karite, makore, touloucouna or babassu oils, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15163091',
        exciseProductCode: 'E200',
        description: 'Microbial fats and oils and their fractions in immediate packings of a net content not exceeding 1kg',
    },
    {
        knNumber: '15171010',
        exciseProductCode: 'E200',
        description: 'Margarine, excluding liquid margarine, containing, by weight, more than 10% but not more than 15% of milkfats',
    },
    {
        knNumber: '15171090',
        exciseProductCode: 'E200',
        description: 'Margarine, excluding liquid margarine, containing, by weight, no more than 10% of milkfats',
    },
    {
        knNumber: '15179010',
        exciseProductCode: 'E200',
        description: 'Edible mixtures or preparations of animals or vegetable fats or oil or of fractions of different fats or oils, containing, by weight, more than 10% but not more than 15% of milkfats',
    },
    {
        knNumber: '15179091',
        exciseProductCode: 'E200',
        description: 'Fixed vegetable oils, fluid, mixed',
    },
    {
        knNumber: '15179093',
        exciseProductCode: 'E200',
        description: 'Edible mixtures or preparations of a kind used as mould-release preparations',
    },
    {
        knNumber: '15179099',
        exciseProductCode: 'E200',
        description: 'Other edible mixtures or preparations of a kind used as mould-release preparations',
    },
    { knNumber: '15180010', exciseProductCode: 'E200', description: 'Linoxyn' },
    {
        knNumber: '15180031',
        exciseProductCode: 'E200',
        description: 'Crude fixed vegetable oils, fluid, mixed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15180039',
        exciseProductCode: 'E200',
        description: 'Fixed vegetable oils, fluid, for technical or industrial uses other than the manufacture of foodstuffs for human consumption',
    },
    {
        knNumber: '15180095',
        exciseProductCode: 'E200',
        description: 'Inedible mixtures or preparations of animal or of animal, vegetable or microbial fats and oils and their fractions',
    },
    {
        knNumber: '22030001',
        exciseProductCode: 'B000',
        description: 'Beer made from malt in bottles holding 10 litres or less',
    },
    {
        knNumber: '22030009',
        exciseProductCode: 'B000',
        description: 'Beer made from malt in containers other than bottles holding 10 litres or less',
    },
    {
        knNumber: '22030010',
        exciseProductCode: 'B000',
        description: 'Beer made from malt in containers holding more than 10 litres',
    },
    {
        knNumber: '22041011',
        exciseProductCode: 'W300',
        description: 'Champagne with a protected designation of origin (PDO)',
    },
    {
        knNumber: '22041013',
        exciseProductCode: 'W300',
        description: 'Cava with a protected designation of origin (PDO)',
    },
    {
        knNumber: '22041015',
        exciseProductCode: 'W300',
        description: 'Prosecco with a protected designation of origin (PDO)',
    },
    {
        knNumber: '22041091',
        exciseProductCode: 'W300',
        description: 'Asti spumante with a protected designation of origin (PDO)',
    },
    {
        knNumber: '22041093',
        exciseProductCode: 'W300',
        description: 'Other sparkling wine with a protected designation of origin (PDO)',
    },
    {
        knNumber: '22041094',
        exciseProductCode: 'W300',
        description: 'Sparkling wine with a protected geographical indication (PGI)',
    },
    {
        knNumber: '22041096',
        exciseProductCode: 'W300',
        description: 'Other varietal sparkling wines',
    },
    {
        knNumber: '22041098',
        exciseProductCode: 'W300',
        description: 'Other sparkling wine',
    },
    {
        knNumber: '22042106',
        exciseProductCode: 'W200',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar meas...; with a protected designation of origin (PDO)",
    },
    {
        knNumber: '22042106',
        exciseProductCode: 'W300',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar meas...; with a protected designation of origin (PDO)",
    },
    {
        knNumber: '22042107',
        exciseProductCode: 'W200',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar me...; with a protected geographical indication (PGI)",
    },
    {
        knNumber: '22042107',
        exciseProductCode: 'W300',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar me...; with a protected geographical indication (PGI)",
    },
    {
        knNumber: '22042108',
        exciseProductCode: 'W200',
        description: "Other varietal wines in bottles with 'mushroom' stoppers held in place by ties or fastenings; other varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temper...",
    },
    {
        knNumber: '22042108',
        exciseProductCode: 'W300',
        description: "Other varietal wines in bottles with 'mushroom' stoppers held in place by ties or fastenings; other varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temper...",
    },
    {
        knNumber: '22042109',
        exciseProductCode: 'W200',
        description: "Non-varietal wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; non-varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature...",
    },
    {
        knNumber: '22042109',
        exciseProductCode: 'W300',
        description: "Non-varietal wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; non-varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature...",
    },
    {
        knNumber: '22042111',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Alsace in containers holding 2 litres or less',
    },
    {
        knNumber: '22042112',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding 2 litres or less',
    },
    {
        knNumber: '22042113',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne in containers holding 2 litres or less',
    },
    {
        knNumber: '22042117',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire in containers holding 2 litres or less',
    },
    {
        knNumber: '22042118',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Mosel in containers holding 2 litres or less',
    },
    {
        knNumber: '22042119',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Pfalz in containers holding 2 litres or less',
    },
    {
        knNumber: '22042122',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rheinhessen in containers holding 2 litres or less',
    },
    {
        knNumber: '22042123',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Tokaj in containers holding 2 litres or less',
    },
    {
        knNumber: '22042124',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Lazio in containers holding 2 litres or less',
    },
    {
        knNumber: '22042126',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Toscana in containers holding 2 litres or less',
    },
    {
        knNumber: '22042127',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Trentino, Alto Adige and Friuli in containers holding 2 litres or less',
    },
    {
        knNumber: '22042128',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Veneto in containers holding 2 litres or less',
    },
    {
        knNumber: '22042131',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Sicilia in containers holding 2 litres or less',
    },
    {
        knNumber: '22042132',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vinho Verde in containers holding 2 litres or less',
    },
    {
        knNumber: '22042134',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Penedés in containers holding 2 litres or less',
    },
    {
        knNumber: '22042136',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rioja in containers holding 2 litres or less',
    },
    {
        knNumber: '22042137',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Valencia in containers holding 2 litres or less',
    },
    {
        knNumber: '22042138',
        exciseProductCode: 'I000',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, produced in the Community in a region other than Alsace, Bordeaux, Bourgogne, Val de Loire, ...',
    },
    {
        knNumber: '22042138',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, produced in the Community in a region other than Alsace, Bordeaux, Bourgogne, Val de Loire, ...',
    },
    {
        knNumber: '22042142',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding 2 litres or less',
    },
    {
        knNumber: '22042143',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne in containers holding 2 litres or less',
    },
    {
        knNumber: '22042144',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding 2 litres or less',
    },
    {
        knNumber: '22042146',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding 2 litres or less',
    },
    {
        knNumber: '22042147',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding 2 litres or less',
    },
    {
        knNumber: '22042148',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire in containers holding 2 litres or less',
    },
    {
        knNumber: '22042161',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Sicilia in containers holding 2 litres or less',
    },
    {
        knNumber: '22042162',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte in containers holding 2 litres or less',
    },
    {
        knNumber: '22042166',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Toscana in containers holding 2 litres or less',
    },
    {
        knNumber: '22042167',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Trentino and Alto Adige in containers holding 2 litres or less',
    },
    {
        knNumber: '22042168',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Veneto in containers holding 2 litres or less',
    },
    {
        knNumber: '22042169',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Dão, Bairrada and Douro in containers holding 2 litres or less',
    },
    {
        knNumber: '22042171',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Navarra in containers holding 2 litres or less',
    },
    {
        knNumber: '22042174',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Penedés in containers holding 2 litres or less',
    },
    {
        knNumber: '22042176',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rioja in containers holding 2 litres or less',
    },
    {
        knNumber: '22042177',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Valdepeñas in containers holding 2 litres or less',
    },
    {
        knNumber: '22042178',
        exciseProductCode: 'W200',
        description: 'Wine,other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, produced in the Community in a region other than Bordeaux, Bourgogne, Beaujolais...',
    },
    {
        knNumber: '22042179',
        exciseProductCode: 'W200',
        description: 'White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22042180',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22042181',
        exciseProductCode: 'I000',
        description: 'White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, other than wine with a protected designation of origin (PDO) or a protected geographical indication ...',
    },
    {
        knNumber: '22042181',
        exciseProductCode: 'W200',
        description: 'White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, other than wine with a protected designation of origin (PDO) or a protected geographical indication ...',
    },
    {
        knNumber: '22042182',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, other than wine with a protected designation of origin (PDO) or a protected geographical...',
    },
    {
        knNumber: '22042183',
        exciseProductCode: 'W200',
        description: 'Non-varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22042184',
        exciseProductCode: 'W200',
        description: 'Non-varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22042185',
        exciseProductCode: 'I000',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042185',
        exciseProductCode: 'S200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042185',
        exciseProductCode: 'W200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042186',
        exciseProductCode: 'I000',
        description: 'Sherry wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042186',
        exciseProductCode: 'S200',
        description: 'Sherry wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042186',
        exciseProductCode: 'W200',
        description: 'Sherry wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042187',
        exciseProductCode: 'I000',
        description: 'Marsala wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042187',
        exciseProductCode: 'S200',
        description: 'Marsala wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042187',
        exciseProductCode: 'W200',
        description: 'Marsala wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042188',
        exciseProductCode: 'I000',
        description: 'Samos and Muscat de Lemnos wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042188',
        exciseProductCode: 'S200',
        description: 'Samos and Muscat de Lemnos wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042188',
        exciseProductCode: 'W200',
        description: 'Samos and Muscat de Lemnos wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042189',
        exciseProductCode: 'I000',
        description: 'Port wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042189',
        exciseProductCode: 'S200',
        description: 'Port wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042189',
        exciseProductCode: 'W200',
        description: 'Port wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042190',
        exciseProductCode: 'I000',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol in containers holding 2 litres or less, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and Setubal ...',
    },
    {
        knNumber: '22042190',
        exciseProductCode: 'S200',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol in containers holding 2 litres or less, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and Setubal ...',
    },
    {
        knNumber: '22042190',
        exciseProductCode: 'W200',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol in containers holding 2 litres or less, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and Setubal ...',
    },
    {
        knNumber: '22042191',
        exciseProductCode: 'I000',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042191',
        exciseProductCode: 'S200',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042191',
        exciseProductCode: 'W200',
        description: 'Wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042193',
        exciseProductCode: 'I000',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042193',
        exciseProductCode: 'S200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042193',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042194',
        exciseProductCode: 'I000',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042194',
        exciseProductCode: 'S200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042194',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042195',
        exciseProductCode: 'I000',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042195',
        exciseProductCode: 'S200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042195',
        exciseProductCode: 'W200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042196',
        exciseProductCode: 'I000',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042196',
        exciseProductCode: 'S200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042196',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042197',
        exciseProductCode: 'I000',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042197',
        exciseProductCode: 'S200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042197',
        exciseProductCode: 'W200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042198',
        exciseProductCode: 'I000',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042198',
        exciseProductCode: 'S200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042198',
        exciseProductCode: 'W200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding 2 litres or less',
    },
    {
        knNumber: '22042210',
        exciseProductCode: 'W200',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...",
    },
    {
        knNumber: '22042210',
        exciseProductCode: 'W300',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...",
    },
    {
        knNumber: '22042222',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042223',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne (Burgundy) in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042224',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042226',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042227',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042228',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire (Loire Valley) in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042232',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte (Piedmont) in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042233',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Tokaj in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042238',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community in a region other than Bordeaux, Bou...',
    },
    {
        knNumber: '22042278',
        exciseProductCode: 'W200',
        description: 'Wine,other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community in a region other than B...',
    },
    {
        knNumber: '22042279',
        exciseProductCode: 'W200',
        description: 'White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042280',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042281',
        exciseProductCode: 'W200',
        description: 'White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, other than wine with a protected designation of origin (PDO) or a prot...',
    },
    {
        knNumber: '22042282',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, other than wine with a protected designation of origin (PD...',
    },
    {
        knNumber: '22042283',
        exciseProductCode: 'W200',
        description: 'Non varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042284',
        exciseProductCode: 'W200',
        description: 'Non varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042285',
        exciseProductCode: 'I000',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042285',
        exciseProductCode: 'S200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042285',
        exciseProductCode: 'W200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042286',
        exciseProductCode: 'I000',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042286',
        exciseProductCode: 'S200',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042286',
        exciseProductCode: 'W200',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042288',
        exciseProductCode: 'I000',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042288',
        exciseProductCode: 'S200',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042288',
        exciseProductCode: 'W200',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042290',
        exciseProductCode: 'I000',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other t...',
    },
    {
        knNumber: '22042290',
        exciseProductCode: 'S200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other t...',
    },
    {
        knNumber: '22042290',
        exciseProductCode: 'W200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other t...',
    },
    {
        knNumber: '22042291',
        exciseProductCode: 'I000',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042291',
        exciseProductCode: 'S200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042291',
        exciseProductCode: 'W200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042293',
        exciseProductCode: 'I000',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042293',
        exciseProductCode: 'S200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042293',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042294',
        exciseProductCode: 'I000',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042294',
        exciseProductCode: 'S200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042294',
        exciseProductCode: 'S300',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042294',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042295',
        exciseProductCode: 'I000',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042295',
        exciseProductCode: 'S200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042295',
        exciseProductCode: 'S300',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042295',
        exciseProductCode: 'W200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042296',
        exciseProductCode: 'I000',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042296',
        exciseProductCode: 'S200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042296',
        exciseProductCode: 'S300',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042296',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042297',
        exciseProductCode: 'I000',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042297',
        exciseProductCode: 'S200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042297',
        exciseProductCode: 'W200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042298',
        exciseProductCode: 'I000',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042298',
        exciseProductCode: 'S200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042298',
        exciseProductCode: 'W200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres',
    },
    {
        knNumber: '22042910',
        exciseProductCode: 'W200',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...",
    },
    {
        knNumber: '22042910',
        exciseProductCode: 'W300',
        description: "Wine in bottles with 'mushroom' stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...",
    },
    {
        knNumber: '22042922',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding more than 10 litres',
    },
    {
        knNumber: '22042923',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne (Burgundy) in containers holding more than 10 litres',
    },
    {
        knNumber: '22042924',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding more than 10 litres',
    },
    {
        knNumber: '22042926',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding more than 10 litres',
    },
    {
        knNumber: '22042927',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding more than 10 litres',
    },
    {
        knNumber: '22042928',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire (Loire Valley) in containers holding more than 10 litres',
    },
    {
        knNumber: '22042932',
        exciseProductCode: 'W200',
        description: 'Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte (Piedmont) in containers holding more than 10 litres',
    },
    {
        knNumber: '22042938',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, produced in the Community in a region other than Bordeaux, Bourgogne (Burgundy), Beaujola...',
    },
    {
        knNumber: '22042978',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, produced in the Community in a region other than Bordeaux, Bourgogne (Burgun...',
    },
    {
        knNumber: '22042979',
        exciseProductCode: 'W200',
        description: 'White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres',
    },
    {
        knNumber: '22042980',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres',
    },
    {
        knNumber: '22042981',
        exciseProductCode: 'W200',
        description: 'White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, other than wine with a protected designation of origin (PDO) or a protected geographical indicati...',
    },
    {
        knNumber: '22042982',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, other than wine with a protected designation of origin (PDO) or a protected geographi...',
    },
    {
        knNumber: '22042983',
        exciseProductCode: 'W200',
        description: 'Non varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres',
    },
    {
        knNumber: '22042984',
        exciseProductCode: 'W200',
        description: 'Non varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres',
    },
    {
        knNumber: '22042985',
        exciseProductCode: 'I000',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042985',
        exciseProductCode: 'S200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042985',
        exciseProductCode: 'W200',
        description: 'Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042986',
        exciseProductCode: 'I000',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042986',
        exciseProductCode: 'S200',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042986',
        exciseProductCode: 'W200',
        description: 'Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042988',
        exciseProductCode: 'I000',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042988',
        exciseProductCode: 'S200',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042988',
        exciseProductCode: 'W200',
        description: 'Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042990',
        exciseProductCode: 'I000',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and...',
    },
    {
        knNumber: '22042990',
        exciseProductCode: 'S200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and...',
    },
    {
        knNumber: '22042990',
        exciseProductCode: 'W200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and...',
    },
    {
        knNumber: '22042991',
        exciseProductCode: 'I000',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042991',
        exciseProductCode: 'S200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042991',
        exciseProductCode: 'W200',
        description: 'Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)',
    },
    {
        knNumber: '22042993',
        exciseProductCode: 'I000',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042993',
        exciseProductCode: 'S200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042993',
        exciseProductCode: 'W200',
        description: 'White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042994',
        exciseProductCode: 'I000',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042994',
        exciseProductCode: 'S200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042994',
        exciseProductCode: 'W200',
        description: 'Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042995',
        exciseProductCode: 'I000',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042995',
        exciseProductCode: 'S200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042995',
        exciseProductCode: 'W200',
        description: 'Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042996',
        exciseProductCode: 'I000',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042996',
        exciseProductCode: 'S200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042996',
        exciseProductCode: 'W200',
        description: 'Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042997',
        exciseProductCode: 'I000',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042997',
        exciseProductCode: 'S200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042997',
        exciseProductCode: 'W200',
        description: 'Non-varietal white wine, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042998',
        exciseProductCode: 'I000',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042998',
        exciseProductCode: 'S200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22042998',
        exciseProductCode: 'W200',
        description: 'Non-varietal wine, other than white, not produced in the Community, in containers holding more than 10 litres',
    },
    {
        knNumber: '22043010',
        exciseProductCode: 'W200',
        description: 'Grape must in fermentation or with fermentation arrested otherwise than by the addition of alcohol',
    },
    {
        knNumber: '22043096',
        exciseProductCode: 'W200',
        description: 'Concentrated grape must of a density exceeding 1.33 g/cm3 at 20° C and of an actual strength exceeding 1% vol.',
    },
    {
        knNumber: '22043098',
        exciseProductCode: 'W200',
        description: 'Not concentrated grape must of a density exceeding 1.33 g/cm3 at 20° C and of an actual strength exceeding 1% vol.',
    },
    {
        knNumber: '22051010',
        exciseProductCode: 'I000',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding 2 litres or less',
    },
    {
        knNumber: '22051010',
        exciseProductCode: 'W200',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding 2 litres or less',
    },
    {
        knNumber: '22051010',
        exciseProductCode: 'W300',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding 2 litres or less',
    },
    {
        knNumber: '22051090',
        exciseProductCode: 'I000',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22051090',
        exciseProductCode: 'S200',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding 2 litres or less',
    },
    {
        knNumber: '22059010',
        exciseProductCode: 'I000',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding more than 2 litres',
    },
    {
        knNumber: '22059010',
        exciseProductCode: 'W200',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding more than 2 litres',
    },
    {
        knNumber: '22059010',
        exciseProductCode: 'W300',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding more than 2 litres',
    },
    {
        knNumber: '22059090',
        exciseProductCode: 'I000',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding more than 2 litres',
    },
    {
        knNumber: '22059090',
        exciseProductCode: 'S200',
        description: 'Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding more than 2 litres',
    },
    { knNumber: '22060010', exciseProductCode: 'I000', description: 'Piquette' },
    { knNumber: '22060010', exciseProductCode: 'S200', description: 'Piquette' },
    { knNumber: '22060010', exciseProductCode: 'W200', description: 'Piquette' },
    {
        knNumber: '22060031',
        exciseProductCode: 'I000',
        description: 'Sparkling cider and perry',
    },
    {
        knNumber: '22060031',
        exciseProductCode: 'S200',
        description: 'Sparkling cider and perry',
    },
    {
        knNumber: '22060031',
        exciseProductCode: 'W200',
        description: 'Sparkling cider and perry',
    },
    {
        knNumber: '22060031',
        exciseProductCode: 'W300',
        description: 'Sparkling cider and perry',
    },
    {
        knNumber: '22060039',
        exciseProductCode: 'B000',
        description: 'Other sparkling fermented beverages',
    },
    {
        knNumber: '22060039',
        exciseProductCode: 'I000',
        description: 'Other sparkling fermented beverages',
    },
    {
        knNumber: '22060039',
        exciseProductCode: 'S200',
        description: 'Other sparkling fermented beverages',
    },
    {
        knNumber: '22060039',
        exciseProductCode: 'W200',
        description: 'Other sparkling fermented beverages',
    },
    {
        knNumber: '22060039',
        exciseProductCode: 'W300',
        description: 'Other sparkling fermented beverages',
    },
    {
        knNumber: '22060051',
        exciseProductCode: 'I000',
        description: 'Still cider and perry in containers holding 2 litres or less',
    },
    {
        knNumber: '22060051',
        exciseProductCode: 'S200',
        description: 'Still cider and perry in containers holding 2 litres or less',
    },
    {
        knNumber: '22060051',
        exciseProductCode: 'W200',
        description: 'Still cider and perry in containers holding 2 litres or less',
    },
    {
        knNumber: '22060059',
        exciseProductCode: 'B000',
        description: 'Other still fermented beverages in containers holding 2 litres or less',
    },
    {
        knNumber: '22060059',
        exciseProductCode: 'I000',
        description: 'Other still fermented beverages in containers holding 2 litres or less',
    },
    {
        knNumber: '22060059',
        exciseProductCode: 'S200',
        description: 'Other still fermented beverages in containers holding 2 litres or less',
    },
    {
        knNumber: '22060059',
        exciseProductCode: 'W200',
        description: 'Other still fermented beverages in containers holding 2 litres or less',
    },
    {
        knNumber: '22060081',
        exciseProductCode: 'I000',
        description: 'Still cider and perry in containers holding more than 2 litres',
    },
    {
        knNumber: '22060081',
        exciseProductCode: 'S200',
        description: 'Still cider and perry in containers holding more than 2 litres',
    },
    {
        knNumber: '22060081',
        exciseProductCode: 'W200',
        description: 'Still cider and perry in containers holding more than 2 litres',
    },
    {
        knNumber: '22060089',
        exciseProductCode: 'B000',
        description: 'Other still fermented beverages in containers holding more than 2 litres',
    },
    {
        knNumber: '22060089',
        exciseProductCode: 'I000',
        description: 'Other still fermented beverages in containers holding more than 2 litres',
    },
    {
        knNumber: '22060089',
        exciseProductCode: 'S200',
        description: 'Other still fermented beverages in containers holding more than 2 litres',
    },
    {
        knNumber: '22060089',
        exciseProductCode: 'W200',
        description: 'Other still fermented beverages in containers holding more than 2 litres',
    },
    {
        knNumber: '22071000',
        exciseProductCode: 'S300',
        description: 'Undenatured ethyl alcohol of an alcoholic strength by volume of 80% vol. or higher',
    },
    {
        knNumber: '22072000',
        exciseProductCode: 'S400',
        description: 'Ethyl alcohol and other spirits, denatured, of any strength',
    },
    {
        knNumber: '22082012',
        exciseProductCode: 'S200',
        description: 'Cognac obtained by distilling grape wine in containers holding 2 litres or less',
    },
    {
        knNumber: '22082014',
        exciseProductCode: 'S200',
        description: 'Armagnac obtained by distilling grape wine in containers holding 2 litres or less',
    },
    {
        knNumber: '22082016',
        exciseProductCode: 'S200',
        description: 'Brandy de Jerez obtained by distilling grape wine in containers holding 2 litres or less',
    },
    {
        knNumber: '22082018',
        exciseProductCode: 'S200',
        description: 'Brandy or Weinbrand obtained by distilling grape wine in containers holding 2 litres or less other than Brandy de Jerez',
    },
    {
        knNumber: '22082019',
        exciseProductCode: 'S200',
        description: 'Spirits obtained by distilling grape wine in containers holding 2 litres or less other than Cognac, Armagnac and Brandy or Weinbrand',
    },
    {
        knNumber: '22082026',
        exciseProductCode: 'S200',
        description: 'Grappa obtained by distilling grape marc in containers holding 2 litres or less',
    },
    {
        knNumber: '22082028',
        exciseProductCode: 'S200',
        description: 'Spirits obtained by distilling grape marc in containers holding 2 litres or less other than Grappa',
    },
    {
        knNumber: '22082062',
        exciseProductCode: 'S200',
        description: 'Cognac obtained by distilling grape wine in containers holding more than 2 litres',
    },
    {
        knNumber: '22082066',
        exciseProductCode: 'S200',
        description: 'Brandy or Weinbrand obtained by distilling grape wine in containers holding more than 2 litres',
    },
    {
        knNumber: '22082069',
        exciseProductCode: 'S200',
        description: 'Spirits obtained by distilling grape wine in contains holding more than 2 litres other than Cognac or Brandy or Weinbrand',
    },
    {
        knNumber: '22082086',
        exciseProductCode: 'S200',
        description: 'Grappa obtained by distilling grape marc in contains holding more than 2 litres',
    },
    {
        knNumber: '22082088',
        exciseProductCode: 'S200',
        description: 'Spirits obtained by distilling grape marc in contains holding more than 2 litres other than Grappa',
    },
    {
        knNumber: '22083011',
        exciseProductCode: 'S200',
        description: 'Bourbon whiskey, in containers holding 2 litres or less',
    },
    {
        knNumber: '22083019',
        exciseProductCode: 'S200',
        description: 'Bourbon whiskey, in containers holding more than 2 litres',
    },
    {
        knNumber: '22083030',
        exciseProductCode: 'S200',
        description: 'Scotch whisky, single malt',
    },
    {
        knNumber: '22083041',
        exciseProductCode: 'S200',
        description: 'Scotch whisky, blended malt whisky, in containers holding 2 litres or less',
    },
    {
        knNumber: '22083049',
        exciseProductCode: 'S200',
        description: 'Scotch whisky, blended malt whisky, in containers holding more than 2 litres',
    },
    {
        knNumber: '22083061',
        exciseProductCode: 'S200',
        description: 'Scotch whisky, single grain and blended grain whisky, in containers holding 2 litres or less',
    },
    {
        knNumber: '22083069',
        exciseProductCode: 'S200',
        description: 'Scotch whisky, single grain and blended grain whisky, in containers holding more than 2 litres',
    },
    {
        knNumber: '22083071',
        exciseProductCode: 'S200',
        description: 'Other Scotch blended whisky, in containers holding 2 litres or less',
    },
    {
        knNumber: '22083079',
        exciseProductCode: 'S200',
        description: 'Other Scotch blended whisky, in containers holding more than 2 litres',
    },
    {
        knNumber: '22083082',
        exciseProductCode: 'S200',
        description: 'Whiskey, in containers holding 2 litres or less',
    },
    {
        knNumber: '22083088',
        exciseProductCode: 'S200',
        description: 'Whiskey, in containers holding more than 2 litres',
    },
    {
        knNumber: '22084011',
        exciseProductCode: 'S200',
        description: 'Rum with a content of volatile substances other than ethyl and methyl alcohol equal to or exceeding 225 grams per hectolitre of pure alcohol in containers holding 2 litres or less',
    },
    {
        knNumber: '22084031',
        exciseProductCode: 'S200',
        description: 'Tafia of a value exceeding €7.9 per litre of pure alcohol in containers holding 2 litres or less',
    },
    {
        knNumber: '22084039',
        exciseProductCode: 'S200',
        description: 'Other tafia in containers holding 2 litres or less',
    },
    {
        knNumber: '22084051',
        exciseProductCode: 'S200',
        description: 'Rum with a content of volatile substances other than ethyl and methyl alcohol equal to or exceeding 225 grams per hectolitre of pure alcohol in containers holding more than 2 litres',
    },
    {
        knNumber: '22084091',
        exciseProductCode: 'S200',
        description: 'Tafia of a value exceeding €2 per litre of pure alcohol in containers holding more than 2 litres',
    },
    {
        knNumber: '22084099',
        exciseProductCode: 'S200',
        description: 'Other tafia in containers holding more than 2 litres',
    },
    {
        knNumber: '22085011',
        exciseProductCode: 'S200',
        description: 'Gin, in containers holding 2 litres or less',
    },
    {
        knNumber: '22085019',
        exciseProductCode: 'S200',
        description: 'Gin, in containers holding more than 2 litres',
    },
    {
        knNumber: '22085091',
        exciseProductCode: 'S200',
        description: 'Geneva, in containers holding 2 litres or less',
    },
    {
        knNumber: '22085099',
        exciseProductCode: 'S200',
        description: 'Geneva, in containers holding more than 2 litres',
    },
    {
        knNumber: '22086011',
        exciseProductCode: 'S200',
        description: 'Vodka of an alcoholic strength by volume of 45.4% vol. or less, in containers holding 2 litres or less',
    },
    {
        knNumber: '22086019',
        exciseProductCode: 'S200',
        description: 'Vodka of an alcoholic strength by volume of 45.4% vol. or less, in containers holding more than 2 litres',
    },
    {
        knNumber: '22086091',
        exciseProductCode: 'S200',
        description: 'Vodka of an alcoholic strength by volume of more than 45.4% vol., in containers holding 2 litres or less',
    },
    {
        knNumber: '22086099',
        exciseProductCode: 'S200',
        description: 'Vodka of an alcoholic strength by volume of more than 45.4% vol., in containers more than 2 litres',
    },
    {
        knNumber: '22087010',
        exciseProductCode: 'S200',
        description: 'Liqueurs and cordials, in containers holding 2 litres or less',
    },
    {
        knNumber: '22087090',
        exciseProductCode: 'S200',
        description: 'Liqueurs and cordials, in containers holding more than 2 litres',
    },
    {
        knNumber: '22089011',
        exciseProductCode: 'S200',
        description: 'Arrack, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089019',
        exciseProductCode: 'S200',
        description: 'Arrack, in containers holding more than 2 litres',
    },
    {
        knNumber: '22089033',
        exciseProductCode: 'S200',
        description: 'Plum, pear or cherry spirit in containers holding 2 litres or less',
    },
    {
        knNumber: '22089038',
        exciseProductCode: 'S200',
        description: 'Plum, pear or cherry spirit in containers holding more than 2 litres',
    },
    {
        knNumber: '22089041',
        exciseProductCode: 'S200',
        description: 'Ouzo, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089045',
        exciseProductCode: 'S200',
        description: 'Calvados, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089048',
        exciseProductCode: 'S200',
        description: 'Spirit (excluding liqueurs) distilled from fruit, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089054',
        exciseProductCode: 'S200',
        description: 'Tequila, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089056',
        exciseProductCode: 'S200',
        description: 'Spirit (excluding liqueurs), in containers holding 2 litres or less',
    },
    {
        knNumber: '22089069',
        exciseProductCode: 'S200',
        description: 'Spirituous beverages, in containers holding 2 litres or less',
    },
    {
        knNumber: '22089071',
        exciseProductCode: 'S200',
        description: 'Spirit (excluding liqueurs) distilled from fruit, in containers holding more than 2 litres',
    },
    {
        knNumber: '22089075',
        exciseProductCode: 'S200',
        description: 'Tequila, in containers holding more than 2 litres',
    },
    {
        knNumber: '22089077',
        exciseProductCode: 'S200',
        description: 'Spirit (excluding liqueurs), in containers holding more than 2 litres',
    },
    {
        knNumber: '22089078',
        exciseProductCode: 'S200',
        description: 'Spirituous beverages, in containers holding more than 2 litres',
    },
    {
        knNumber: '22089091',
        exciseProductCode: 'S300',
        description: 'Undenatured ethyl alcohol of an alcoholic strength by volume of less than 80% vol., in containers holding 2 litres or less',
    },
    {
        knNumber: '22089099',
        exciseProductCode: 'S300',
        description: 'Undenatured ethyl alcohol of an alcoholic strength by volume of less than 80% vol., in containers holding more than 2 litres',
    },
    {
        knNumber: '24021000',
        exciseProductCode: 'T300',
        description: 'Cigars, cheroots and cigarillos containing tobacco',
    },
    {
        knNumber: '24022010',
        exciseProductCode: 'T200',
        description: 'Cigarettes containing tobacco / containing cloves',
    },
    {
        knNumber: '24022090',
        exciseProductCode: 'T200',
        description: 'Cigarettes containing tobacco / other',
    },
    {
        knNumber: '24029000',
        exciseProductCode: 'T200',
        description: 'Cigars, cheroots, cigarillos and cigarettes not containing tobacco',
    },
    {
        knNumber: '24029000',
        exciseProductCode: 'T400',
        description: 'Cigars, cheroots, cigarillos and cigarettes not containing tobacco',
    },
    {
        knNumber: '24029000',
        exciseProductCode: 'T500',
        description: 'Cigars, cheroots, cigarillos and cigarettes not containing tobacco',
    },
    {
        knNumber: '24031100',
        exciseProductCode: 'T500',
        description: 'Water-pipe tobacco specified in subheading note 1 to chapter 24 of the CN',
    },
    {
        knNumber: '24031910',
        exciseProductCode: 'T400',
        description: 'Smoking tobacco in immediate packing of a net content not exceeding 500 g',
    },
    {
        knNumber: '24031910',
        exciseProductCode: 'T500',
        description: 'Smoking tobacco in immediate packing of a net content not exceeding 500 g',
    },
    {
        knNumber: '24031990',
        exciseProductCode: 'T400',
        description: 'Smoking tobacco, other',
    },
    {
        knNumber: '24031990',
        exciseProductCode: 'T500',
        description: 'Smoking tobacco, other',
    },
    {
        knNumber: '24039100',
        exciseProductCode: 'T400',
        description: "Homogenised' or 'reconstituted' tobacco",
    },
    {
        knNumber: '24039100',
        exciseProductCode: 'T500',
        description: "Homogenised' or 'reconstituted' tobacco",
    },
    {
        knNumber: '24039990',
        exciseProductCode: 'T400',
        description: 'Other manufactured tobacco and tobacco substitutes',
    },
    {
        knNumber: '24039990',
        exciseProductCode: 'T500',
        description: 'Other manufactured tobacco and tobacco substitutes',
    },
    {
        knNumber: '27071000',
        exciseProductCode: 'E300',
        description: 'Benzol (benzene)',
    },
    {
        knNumber: '27072000',
        exciseProductCode: 'E300',
        description: 'Toluol (toluene)',
    },
    {
        knNumber: '27073000',
        exciseProductCode: 'E300',
        description: 'Xylol (xylenes)',
    },
    {
        knNumber: '27075000',
        exciseProductCode: 'E300',
        description: 'Other aromatic hydrocarbon mixtures of which 65 % or more by volume (including losses) distils at 250 °C by the ISO 3405 method (equivalent to the ASTM D 86 method)',
    },
    {
        knNumber: '27101211',
        exciseProductCode: 'E490',
        description: 'Lights oil for undergoing a specific process',
    },
    {
        knNumber: '27101215',
        exciseProductCode: 'E490',
        description: 'Lights oil for undergoing chemical transformations',
    },
    {
        knNumber: '27101221',
        exciseProductCode: 'E480',
        description: 'White spirit',
    },
    {
        knNumber: '27101225',
        exciseProductCode: 'E480',
        description: 'Light oil for other purposes',
    },
    {
        knNumber: '27101231',
        exciseProductCode: 'E410',
        description: 'Aviation spirit',
    },
    {
        knNumber: '27101231',
        exciseProductCode: 'E420',
        description: 'Aviation spirit',
    },
    {
        knNumber: '27101241',
        exciseProductCode: 'E420',
        description: 'Light oil with a lead content not exceeding 0.013 g per litre with an octane number of less than 95',
    },
    {
        knNumber: '27101245',
        exciseProductCode: 'E420',
        description: 'Light oil with a lead content not exceeding 0.013 g per litre with an octane number of 95 or more but less than 98',
    },
    {
        knNumber: '27101249',
        exciseProductCode: 'E420',
        description: 'Light oil with a lead content not exceeding 0.013 g per litre with an octane number of less than 98 or more',
    },
    {
        knNumber: '27101250',
        exciseProductCode: 'E410',
        description: 'Light oil with a lead content exceeding 0.013 g per litre',
    },
    {
        knNumber: '27101270',
        exciseProductCode: 'E490',
        description: 'Spirit type jet fuel',
    },
    {
        knNumber: '27101290',
        exciseProductCode: 'E490',
        description: 'Other light oil',
    },
    {
        knNumber: '27101911',
        exciseProductCode: 'E490',
        description: 'Medium oil for undergoing a specific process',
    },
    {
        knNumber: '27101915',
        exciseProductCode: 'E490',
        description: 'Medium oil for undergoing chemical transformation',
    },
    {
        knNumber: '27101921',
        exciseProductCode: 'E450',
        description: 'Jet fuel kerosene',
    },
    {
        knNumber: '27101925',
        exciseProductCode: 'E450',
        description: 'Other kerosene',
    },
    {
        knNumber: '27101925',
        exciseProductCode: 'E460',
        description: 'Other kerosene',
    },
    {
        knNumber: '27101929',
        exciseProductCode: 'E480',
        description: 'Medium oils for other purposes',
    },
    {
        knNumber: '27101931',
        exciseProductCode: 'E490',
        description: 'Heavy gas oil for undergoing a specific process',
    },
    {
        knNumber: '27101935',
        exciseProductCode: 'E490',
        description: 'Heavy gas oil for undergoing chemical transformation',
    },
    {
        knNumber: '27101943',
        exciseProductCode: 'E430',
        description: 'Heavy gas oil with a sulphur content not exceeding 0.001% by weight, not containing biodiesel',
    },
    {
        knNumber: '27101943',
        exciseProductCode: 'E440',
        description: 'Heavy gas oil with a sulphur content not exceeding 0.001% by weight, not containing biodiesel',
    },
    {
        knNumber: '27101946',
        exciseProductCode: 'E430',
        description: 'Heavy gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.002%, not containing biodiesel',
    },
    {
        knNumber: '27101946',
        exciseProductCode: 'E440',
        description: 'Heavy gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.002%, not containing biodiesel',
    },
    {
        knNumber: '27101947',
        exciseProductCode: 'E430',
        description: 'Heavy gas oil with a sulphur content exceeding 0.002% by weight but not exceeding 0.1%, not containing biodiesel',
    },
    {
        knNumber: '27101947',
        exciseProductCode: 'E440',
        description: 'Heavy gas oil with a sulphur content exceeding 0.002% by weight but not exceeding 0.1%, not containing biodiesel',
    },
    {
        knNumber: '27101948',
        exciseProductCode: 'E430',
        description: 'Heavy gas oil with a sulphur content exceeding 0.1% by weight, not containing biodiesel',
    },
    {
        knNumber: '27101948',
        exciseProductCode: 'E440',
        description: 'Heavy gas oil with a sulphur content exceeding 0.1% by weight, not containing biodiesel',
    },
    {
        knNumber: '27101951',
        exciseProductCode: 'E490',
        description: 'Heavy fuel oil for undergoing a specific process',
    },
    {
        knNumber: '27101955',
        exciseProductCode: 'E490',
        description: 'Heavy fuel oil for undergoing chemical transformation',
    },
    {
        knNumber: '27101962',
        exciseProductCode: 'E470',
        description: 'Heavy fuel oil with a sulphur content not exceeding 0.1% by weight, not containing biodiesel',
    },
    {
        knNumber: '27101966',
        exciseProductCode: 'E470',
        description: 'Heavy fuel oil with a sulphur content exceeding 0.1% by weight but not exceeding 0.5%, not containing biodiesel',
    },
    {
        knNumber: '27101967',
        exciseProductCode: 'E470',
        description: 'Heavy fuel oil with a sulphur content exceeding 0.5% by weight, not containing biodiesel',
    },
    {
        knNumber: '27102011',
        exciseProductCode: 'E430',
        description: 'Gas oil with a sulphur content not exceeding 0.001% by weight, containing biodiesel',
    },
    {
        knNumber: '27102011',
        exciseProductCode: 'E440',
        description: 'Gas oil with a sulphur content not exceeding 0.001% by weight, containing biodiesel',
    },
    {
        knNumber: '27102016',
        exciseProductCode: 'E430',
        description: 'Gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.1%, containing biodiesel',
    },
    {
        knNumber: '27102016',
        exciseProductCode: 'E440',
        description: 'Gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.1%, containing biodiesel',
    },
    {
        knNumber: '27102019',
        exciseProductCode: 'E430',
        description: 'Gas oil with a sulphur content exceeding 0.1% by weight, containing biodiesel',
    },
    {
        knNumber: '27102019',
        exciseProductCode: 'E440',
        description: 'Gas oil with a sulphur content exceeding 0.1% by weight, containing biodiesel',
    },
    {
        knNumber: '27102032',
        exciseProductCode: 'E470',
        description: 'Fuel oil with a sulphur content not exceeding 0.5% by weight, containing biodiesel',
    },
    {
        knNumber: '27102038',
        exciseProductCode: 'E470',
        description: 'Fuel oil with a sulphur content exceeding 0.5% by weight, containing biodiesel',
    },
    {
        knNumber: '27102090',
        exciseProductCode: 'E480',
        description: 'Oljor erhållna ur petroleum eller ur bituminösa mineral (andra än råolja) och produkter, inte nämnda eller inbegripna någon annanstans, innehållande som karaktärsgivande beståndsdel minst 70 viktprocent oljor erhållna ur petroleum eller ur bituminösa mi...',
    },
    {
        knNumber: '27111211',
        exciseProductCode: 'E500',
        description: 'Liquefied Propane of a purity not less than 99 % for use as a power or heating fuel',
    },
    {
        knNumber: '27111219',
        exciseProductCode: 'E500',
        description: 'Liquefied Propane of a purity not less than 99 % for other purposes',
    },
    {
        knNumber: '27111291',
        exciseProductCode: 'E500',
        description: 'Liquefied Propane of a purity less than 99 % for undergoing a specific process',
    },
    {
        knNumber: '27111293',
        exciseProductCode: 'E500',
        description: 'Liquefied Propane of a purity less than 99 % for undergoing a chemical transformation',
    },
    {
        knNumber: '27111294',
        exciseProductCode: 'E500',
        description: 'Liquefied Propane of a purity exceeding 90% but less than 99%',
    },
    {
        knNumber: '27111297',
        exciseProductCode: 'E500',
        description: 'Liquefied propane of a purity not exceeding 90%',
    },
    {
        knNumber: '27111310',
        exciseProductCode: 'E500',
        description: 'Liquefied Butanes for undergoing a specific process',
    },
    {
        knNumber: '27111330',
        exciseProductCode: 'E500',
        description: 'Liquefied Butanes for undergoing a chemical transformation',
    },
    {
        knNumber: '27111391',
        exciseProductCode: 'E500',
        description: 'Liquefied Butanes of a purity exceeding 90 % but of less than 95 %',
    },
    {
        knNumber: '27111397',
        exciseProductCode: 'E500',
        description: 'Butanes with a purity not exceeding 90% or at or above 95%, which are not intended for undergoing a specific process',
    },
    {
        knNumber: '27111400',
        exciseProductCode: 'E500',
        description: 'Ethylene, propylene, butylenes and butadiene liquefied',
    },
    {
        knNumber: '27111900',
        exciseProductCode: 'E500',
        description: 'Petroleum gases etc., liquefied',
    },
    {
        knNumber: '29011000',
        exciseProductCode: 'E600',
        description: 'Acyclic hydrocarbons saturated',
    },
    { knNumber: '29022000', exciseProductCode: 'E700', description: 'Benzene' },
    { knNumber: '29023000', exciseProductCode: 'E700', description: 'Toluene' },
    { knNumber: '29024100', exciseProductCode: 'E700', description: 'o-Xylene' },
    { knNumber: '29024200', exciseProductCode: 'E700', description: 'm-Xylene' },
    { knNumber: '29024300', exciseProductCode: 'E700', description: 'p-Xylene' },
    {
        knNumber: '29024400',
        exciseProductCode: 'E700',
        description: 'Mixed xylene isomers',
    },
    {
        knNumber: '29051100',
        exciseProductCode: 'E800',
        description: 'Methanol (methyl alcohol)',
    },
    {
        knNumber: '38111110',
        exciseProductCode: 'E930',
        description: 'Anti-knock preparations based on tetraethyl-lead',
    },
    {
        knNumber: '38111190',
        exciseProductCode: 'E930',
        description: 'Anti-knock preparations based on lead compounds other than tetraethyl-lead',
    },
    {
        knNumber: '38111900',
        exciseProductCode: 'E930',
        description: 'Anti-knock preparations other than based on lead compounds',
    },
    {
        knNumber: '38119000',
        exciseProductCode: 'E930',
        description: 'Oxidation inhibitors, gum inhibitors, viscosity improvers, anti-corrosive preparations and other prepared additives, for mineral oils (including gasoline) or for other liquids used for the same purposes as mineral oils other than anti-knock preparation...',
    },
    {
        knNumber: '38248900',
        exciseProductCode: 'E920',
        description: 'Goods specified in subheading note 3 of chapter 38, containing short-chain chlorinated paraffins',
    },
    {
        knNumber: '38249200',
        exciseProductCode: 'E920',
        description: 'Polyglycol esters of methylphosphonic acid other than goods specified in subheading note 3 of chapter 38',
    },
    {
        knNumber: '38249986',
        exciseProductCode: 'E920',
        description: 'Mixtures consisting mainly of dimethyl methylphosphonate, oxirane and diphosphorus pentaoxide',
    },
    {
        knNumber: '38249992',
        exciseProductCode: 'E920',
        description: 'Chemical products or preparations, predominantly composed of organic compounds, not elsewhere specified or included in the form of a liquid at 20 °C',
    },
    {
        knNumber: '38249993',
        exciseProductCode: 'E920',
        description: 'Chemical products or preparations, predominantly composed of organic compounds, not elsewhere specified or included other than in the form of a liquid at 20 °C',
    },
    {
        knNumber: '38249996',
        exciseProductCode: 'E920',
        description: 'Chemical products and preparations of the chemical or allied industries (including those consisting of mixtures of natural products), not elsewhere specified or included',
    },
    {
        knNumber: '38260010',
        exciseProductCode: 'E910',
        description: 'Fatty-acid mono-alkyl esters, containing by volume 96,5 % or more of esters (FAMAE)',
    },
    {
        knNumber: '38260090',
        exciseProductCode: 'E920',
        description: 'Fatty-acid mono-alkyl esters and mixtures thereof, containing by volume less than 96,5 % of esters (FAMAE) and not containing or containing less than 70 % by weight of petroleum oils or oils obtained from bituminous minerals',
    },
];
module.exports = {
    findProductCode: knNumber => {
        const possibilities = knNumbersWithProductCode.filter(x => x.knNumber === knNumber);
        if (possibilities.length > 1) {
            return undefined;
        }
        if (possibilities.length === 1) {
            return possibilities[0].exciseProductCode;
        }
        // did not find it
        return null;
    },
};
